export default "__VITE_ASSET__BplsZ2wh__"